import React from 'react';
import styled from '@emotion/styled';
import 'external-svg-loader';

import { ComponentStyle } from '../../types/types';

import { Config } from '@vm/omega-shared-component-webapp';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const BackgroundPatternContainer = styled.div({
  position: 'absolute',
  overflow: 'hidden',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  // z-index is -1 here to ensure the pattern is behind the content
  zIndex: -1,
});

const BackgroundPatternSvg = styled.svg({
  position: 'absolute',
  left: '44%',
  bottom: pxToRem(-723),
  transform: 'translate(-50%, -50%) rotate(-90deg)',
  width: pxToRem(160),
  height: pxToRem(800),

  [mqBreakpoints.tablet]: {
    left: '85%',
    top: '55%',
    transform: 'translate(-50%, -50%) rotate(0deg)',
    width: pxToRem(240),
    height: pxToRem(1200),
  },

  [mqBreakpoints.desktop]: {
    width: pxToRem(320),
    height: pxToRem(1600),
  },

  '&.A': {
    // Pattern opacity and color is not defined in the style guide, used best guess
    color: 'var(--color-secondary-2)',
    opacity: 0.5,
  },

  '&.B': {
    // Pattern opacity and color is not defined in the style guide, used best guess
    color: 'var(--color-dark)',
    opacity: 0.5,
  },

  '&.C': {
    // Pattern opacity and color defined in the style guide
    color: 'var(--color-black)',
    opacity: 0.05,
  },
});

type Props = {
  style: ComponentStyle;
};

export const CtaBackgroundPattern: React.FC<Props> = ({ style }) => {
  return (
    <BackgroundPatternContainer>
      <BackgroundPatternSvg className={style} data-src={`${Config.get('image_cdn_base_url')}/ui/product-marketplace-webapp/vertical-pattern.svg`} />
    </BackgroundPatternContainer>
  );
};
